import { render, staticRenderFns } from "./ProductPartnersList.vue?vue&type=template&id=5b785c5c&"
import script from "./ProductPartnersList.vue?vue&type=script&lang=js&"
export * from "./ProductPartnersList.vue?vue&type=script&lang=js&"
import style0 from "./ProductPartnersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports